var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lord-icon',{staticClass:"lord-icon emat-icon",class:{ close: _vm.icon === 'close' },attrs:{"src":_vm.getIcon,"trigger":_vm.trigger,"colors":_vm.getColors,"stoke":"100"},on:{"click":function($event){return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }